import React, { Component } from 'react'
import styled from 'styled-components'
import sukiLogo from '../../../lib/assets/icons/suki-logo-navbar.svg'
import sukiLogoWhite from '../../../lib/assets/icons/suki-logo-navbar-white.svg'
import { BREAKPOINT } from '../constants'

const Container = styled.div`
  height: 110px;
  width: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  background: ${props => props.isScrolledDown ? 'white' : 'transparent'};
  box-shadow: ${props => props.isScrolledDown ? '0 0 10px rgba(0,0,0,0.2)' : '0'};
  z-index: 1000;
  transition: all .3s ease;
  top:0;
  left:0;

  @media (max-width: ${BREAKPOINT.SMALL}) {
    height: 55px;
  }
`

const LogoContainer = styled.div`
  height: 23px;
  position: relative;
  
  @media (max-width:  ${BREAKPOINT.SMALL}) {
    height: 17px;
  }
`

const Logo = styled.img`
   height: 100%;
   padding: 0 60px;
   box-sizing: border-box;

   @media (max-width:  ${BREAKPOINT.SMALL}) {
    padding: 0 20px;
  }
`

class Header extends Component {
  render () {
    const { isScrolledDown, isWhite = false } = this.props

    return (
      <Container isScrolledDown={isScrolledDown}>
        <LogoContainer>
          <Logo src={isWhite ? sukiLogoWhite : sukiLogo} />
        </LogoContainer>
      </Container>
    )
  }
}

export default Header
